import React from 'react'
import { Button } from '~/components/UI/shadcn/button'

type Props = {
  children: React.ReactNode
  fallback?: React.ReactNode
  message?: string
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void
}

type State = {
  hasError: boolean
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
    this.resetError = this.resetError.bind(this)
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (this.props.onError) {
      this.props.onError(error, errorInfo)
    }
    console.error('ErrorBoundary caught an error', error, errorInfo)
  }

  resetError() {
    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='flex h-full flex-col items-center justify-center p-4 text-center'>
          {this.props.fallback || (
            <div>Something went wrong with {this.props.message}.</div>
          )}
          <Button
            onClick={this.resetError}
            className='bg-grey-l text-blue-d mt-xs'
          >
            Try again
          </Button>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
